import { ExpressionSpecification } from 'maplibre-gl'

export const createPaintExpression = (
  metricName: string,
  paintExpression: ExpressionSpecification,
): ExpressionSpecification => {
  return [
    'case',
    ['has', metricName],
    paintExpression,
    '#b3b3b3', // if state is missing gray!
  ]
}

export const getSpeedMetricPaint = (metricName: string): ExpressionSpecification => {
  return [
    'interpolate',
    ['linear'],
    ['get', metricName],
    0,
    '#ffffff', // start: white
    10,
    '#ffeaea',
    20,
    '#ffd6d6',
    30,
    '#ffb3b3',
    40,
    '#ff8a8a',
    50,
    '#ff5252',
    60,
    '#ff1744',
    70,
    '#d50000',
    80,
    '#b71c1c',
    90,
    '#a31515',
    100,
    '#8b0000',
    110,
    '#730000',
    120,
    '#5a0000',
    130,
    '#400000',
    140,
    '#2a0000',
    150,
    '#1a0000',
    160,
    '#0a0000',
    170,
    '#8b0000', // last: dark red
  ]
}

export const getProbabilityMetricPaint = (metricName: string): ExpressionSpecification => {
  return [
    'step',
    ['to-number', ['get', metricName]],
    '#ed0007', // default color for values < 0.5
    0.5,
    '#2e8b57', // color for values >= 0.5
  ]
}
